module.exports = __webpack_public_path__ + "static/media/mobile_2.14bb8be9.jpg";